/**
 * Returns a shallow-cloned copy of `obj` with the dot-notation `fieldPath` set to `value`.
 * Intermediate objects are created if missing.
 */
export const setDeepValue = (obj, fieldPath, value) => {
  const pathParts = fieldPath.split('.');
  const updated = { ...obj };
  let current = updated;
  for (let i = 0; i < pathParts.length - 1; i++) {
    current[pathParts[i]] = current[pathParts[i]] ? { ...current[pathParts[i]] } : {};
    current = current[pathParts[i]];
  }
  current[pathParts[pathParts.length - 1]] = value;
  return updated;
};
